import { i as isRtlEnabled } from '../../LocalModules/storm-ui-utils/dist/esm/isRtlEnabled-DXSQ1gyT-C6zs_USs.js';

const EXPANDED_EXIT_TRANSITION_DURATION = 250; // ms
/**
 * The scrollLeft value returned by the browser will be a negative number
 * if the direction is RTL. This function returns a positive value for direction
 * independent of scroll computations. Additionally, the scrollLeft value can be
 * a decimal value on systems using display scaling requiring the floor calls.
 */
function getScrollLeft(element) {
  return Math.abs(Math.floor(element.scrollLeft));
}

// TODO: Adjust for RTL
const hasLeftOverflow = container => {
  if (!container) return false;
  // subtracting 1 due to measurement rounding & border width
  return getScrollLeft(container) - 1 > 0;
};
const hasRightOverflow = container => {
  if (!container) return false;
  // subtracting 1 due to measurement rounding & border width
  return container.scrollWidth - getScrollLeft(container) - container.offsetWidth - 1 > 0;
};
function easeInOutQuad(time) {
  return time < 0.5 ? 2 * time * time : -1 + (4 - 2 * time) * time;
}
const findNextLeftIndex = ({
  containerRect,
  childNodes,
  isRtl
}) => {
  if (isRtl) {
    const scrollToChildIndex = childNodes.findIndex(child => {
      const childRect = child.getBoundingClientRect();
      return Math.floor(containerRect.right - childRect.right) > 1;
    });
    // correct for missing/invalid child
    if (scrollToChildIndex === -1) {
      return childNodes.length - 1;
    }
    if (scrollToChildIndex === 0 && childNodes.length > 0) {
      return 1;
    }
    return scrollToChildIndex;
  }
  // If LTR
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore typescript doesn't understand findLastIndex yet
  const scrollToChildIndex = childNodes.findLastIndex(child => {
    const childRect = child.getBoundingClientRect();
    return Math.floor(containerRect.left - childRect.left) > 1;
  });
  return scrollToChildIndex === -1 ? 0 : scrollToChildIndex;
};
const findNextRightIndex = ({
  containerRect,
  childNodes,
  isRtl
}) => {
  if (isRtl) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore typescript doesn't understand findLastIndex yet
    const scrollToChildIndex = childNodes.findLastIndex(child => {
      const childRect = child.getBoundingClientRect();
      return Math.ceil(containerRect.right - childRect.right) < -1;
    });
    return scrollToChildIndex === -1 ? 0 : scrollToChildIndex;
  }
  // If LTR
  const scrollToChildIndex = childNodes.findIndex(child => {
    const childRect = child.getBoundingClientRect();
    return Math.ceil(containerRect.left - childRect.left) < -1;
  });

  // correct for missing/invalid child
  if (scrollToChildIndex === -1) {
    return childNodes.length - 1;
  }
  if (scrollToChildIndex === 0 && childNodes.length > 0) {
    return 1;
  }
  return scrollToChildIndex;
};
const scrollToChild = ({
  scrollRowRef,
  childNodes,
  direction
}) => {
  if (!(scrollRowRef !== null && scrollRowRef !== void 0 && scrollRowRef.current) || !(childNodes !== null && childNodes !== void 0 && childNodes.length)) return 0;
  const isRtl = isRtlEnabled();
  const container = scrollRowRef.current;
  const containerRect = container.getBoundingClientRect();
  const side = isRtl ? 'right' : 'left';
  let scrollBy = 0;
  let scrollToChildIndex = -1;
  let childRect;
  if (direction === 'left') {
    scrollToChildIndex = findNextLeftIndex({
      containerRect,
      childNodes,
      isRtl
    });
    childRect = childNodes[scrollToChildIndex].getBoundingClientRect();
  } else {
    scrollToChildIndex = findNextRightIndex({
      containerRect,
      childNodes,
      isRtl
    });
    childRect = childNodes[scrollToChildIndex].getBoundingClientRect();
  }
  scrollBy = -Math.floor(containerRect[side] - childRect[side]);
  const startPosition = container.scrollLeft;
  const endPosition = startPosition + scrollBy;
  const duration = 150; // ms

  const animateScroll = startTime => {
    const currentTime = performance.now();
    const elapsedTime = currentTime - startTime;
    if (elapsedTime < duration) {
      const progress = easeInOutQuad(elapsedTime / duration);
      container.scrollLeft = startPosition + (endPosition - startPosition) * progress;
      requestAnimationFrame(() => animateScroll(startTime));
    } else {
      container.scrollLeft = endPosition;
    }
  };
  requestAnimationFrame(startTime => animateScroll(startTime));
  return scrollToChildIndex;
};

export { EXPANDED_EXIT_TRANSITION_DURATION as E, hasRightOverflow as a, hasLeftOverflow as h, scrollToChild as s };
//# sourceMappingURL=utils-Bch8lY8w.js.map
